import { render, staticRenderFns } from "./OrganizationCreateView.vue?vue&type=template&id=f59bbf46&"
import script from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports